import React from 'react';
import './WhatWeDeliver.css';

const WhatWeDeliver = () => {
  const deliverables = [
    {
      icon: '💰',
      title: 'See What\'s Actually Making Money',
      description: 'Know which services drive profit, which time slots go empty, and where demand actually lives.',
      emoji: '✓'
    },
    {
      icon: '📅',
      title: 'Staff Right Before the Week Starts',
      description: 'Match schedules to real demand patterns, not last month\'s habit.',
      emoji: '✓'
    },
    {
      icon: '🏢',
      title: 'Track All Locations in One View',
      description: 'Spot problems before they compound. Know which locations need help and which are ready to scale.',
      emoji: '✓'
    }
  ];

  return (
    <section id="what-we-deliver" className="what-we-deliver-section">
      <div className="container">
        <h2 className="section-title">What Jajoga delivers</h2>

        <div className="deliverables-grid">
          {deliverables.map((item, index) => (
            <div key={index} className="deliverable-card">
              <div className="card-icon">{item.icon}</div>
              <div className="card-check">{item.emoji}</div>
              <h3 className="card-title">{item.title}</h3>
              <p className="card-description">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="footer-message">
          <p className="no-bloat">No bloated dashboards.</p>
          <p className="no-vanity">No vanity metrics.</p>
          <p className="just-insight">Just insight owners actually use.</p>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDeliver;
